// extracted by mini-css-extract-plugin
module.exports = {"textInput":"EditSubsidiary_textInput__181h4","logo":"EditSubsidiary_logo__uE_Rt","activeCheckbox":"EditSubsidiary_activeCheckbox__2gMKB"};